import { render, staticRenderFns } from "./oneboxing.vue?vue&type=template&id=67cccb86&scoped=true"
import script from "./oneboxing.vue?vue&type=script&lang=js"
export * from "./oneboxing.vue?vue&type=script&lang=js"
import style0 from "./oneboxing.vue?vue&type=style&index=0&id=67cccb86&prod&scoped=true&lang=css"
import style1 from "./oneboxing.vue?vue&type=style&index=1&id=67cccb86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cccb86",
  null
  
)

export default component.exports